import { connect as reduxConnect } from "react-redux";
import mixins from ".";
import { parse, stringify, toJSON, fromJSON } from "flatted";
import { APPLY_UPDATER } from "../store/actionTypes";

const isset = (val, def = undefined) => {
  return val === undefined ? def : val;
};
const setStore = function (key, value = null, props = null) {
  props = props || this.props || {};
  let dispatch = props.dispatch;
  if (!dispatch) {
    console.warn("setStore: dispatch unavailable (component not connected?)");
    return;
  }
  let watch = props.watch || this.watch;
  return dispatch((state) => {
    let storeObject = { ...state };
    let updateStore = (payload, storeObject) => {
      let key = payload.name;
      let watchme = watch[key] || ((v) => v);
      let arr = payload.name.split(".");
      if (arr.length > 1) {
        let tmp = storeObject,
          key = "",
          old = null;
        arr.forEach((k) => {
          old = tmp;
          tmp[k] = tmp[k] || {};
          tmp = tmp[k];
          key = k;
        });
        old[key] = isset(watchme(payload.value), payload.value);
      } else {
        storeObject[key] = isset(watchme(payload.value), payload.value);
      }
      return storeObject;
    };
    if (typeof key == "object" && key instanceof Array) {
      key.map((obj) => {
        storeObject = updateStore(obj, storeObject);
      });
    } else {
      storeObject = updateStore({ name: key, value: value }, storeObject);
    }
    return {
      ...storeObject,
    };
  });
};
export default {
  /**
   * App-wide connect: injects full Redux state as `props.store`
   * plus `dispatch` / `setStore` / `watch` helpers.
   * Compatible with React 18 + react-redux 9 + Redux Toolkit.
   */
  connect(component) {
    return reduxConnect(
      (state) => ({ store: state }),
      (dispatch) => {
        let ret = {};
        // Legacy API: dispatch(fn) → string-typed action with updater (RTK-safe)
        ret.dispatch = (func, ...payload) =>
          dispatch({
            type: APPLY_UPDATER,
            updater: func,
            payload: payload,
          });
        ret.setStore = (key, value, props = {}) =>
          setStore.bind(ret)(key, value, { ...props, dispatch: ret.dispatch });
        ret.watch = {};
        return ret;
      },
      null,
      { forwardRef: true }
    )(component);
  },
  /**
   * Bind legacy class helpers onto `this` (or a functional-component `self` bag).
   * Pass current React `props` as the 2nd arg from function components so
   * `this.props.store` is always available.
   */
  initialConstruct(key, propsFromCaller) {
    if (propsFromCaller != null) {
      this.props = propsFromCaller;
    }
    const props = this.props || {};
    this.$store = props.store;
    this.dispatch = props.dispatch;
    this.history = props.history || window.reduxHistory;
    this.setStore = mixins.setStore.bind(this);
    this.setStates = mixins.setStates.bind(this);
    this.debounce = mixins.debounce.bind(this);
    this.lasycall = mixins.lasycall.bind(this);
    this.watch = mixins.watch.bind(this);
    window[key] = this;
  },
  getCurrentPath() {
    return window.reduxHistory ? window.reduxHistory.location.pathname : "";
  },
  getDotedKeyValue(key, obj) {
    let arr = key.split(".");
    if (arr.length > 1) {
      let tmp = obj,
        key = "",
        old = null;
      arr.forEach((k) => {
        ((old = tmp), (tmp = tmp[k]), (key = k));
      });
      return old[key];
    } else {
      return obj[key];
    }
  },
  getDotedValueKeys(key, obj) {
    let arr = key.split(".");
    if (arr.length > 1) {
      let tmp = obj || {},
        key = "",
        old = null;
      arr.forEach((k) => {
        ((old = tmp), (tmp = tmp[k]), (key = k));
      });
      return {
        obj: old,
        key,
      };
    } else {
      return {
        obj,
        key,
      };
    }
  },
  setStore,
  setStates(key, val) {
    let self = this;
    return new Promise((res, rej) => {
      self.setState(
        (...arg) => {
          let ret = mixins.getDotedValueKeys(key, arg[0]);
          let obj = ret.obj;
          ret.obj[ret.key] = typeof val == "function" ? val(...arg) : val;
          return {
            ...arg[0],
          };
        },
        (...arg) => {
          res(...arg);
        },
      );
    });
  },
  watch(watchers, nextState = null, prevState = null) {
    prevState = prevState || { ...this.props };
    let keys = Object.keys(watchers);
    keys.map((key) => {
      let oldval = mixins.getDotedKeyValue(key, prevState);
      let newval = mixins.getDotedKeyValue(key, nextState);
      if (mixins.detectComplexChange(oldval, newval)) {
        let func = watchers[key];
        if (func instanceof Function) {
          func.bind(this)(newval, oldval);
        }
      }
    });
  },
  detectComplexChange(prev, next) {
    let trusy = prev || next;
    if (typeof prev != typeof next || prev == null || next == null) {
      return prev != next;
    } else if (["object"].includes(typeof trusy)) {
      let nextLen =
        trusy instanceof Array ? next.length : Object.entries(next).length;
      let prevLen =
        trusy instanceof Array ? prev.length : Object.entries(prev).length;
      if (prevLen != nextLen) {
        return true;
      } else {
        return JSON.stringify(prev) != JSON.stringify(next);
      }
    } else {
      return prev != next;
    }
  },
  getSelectionText() {
    var txt = "";
    if (window.getSelection) {
      txt = window.getSelection().toString();
    } else if (document.getSelection) {
      txt = document.getSelection().toString();
    } else if (document.selection) {
      txt = document.selection.createRange().text;
    } else return;
    return txt;
  },
  getDataNode(data) {
    let divEle = document.createElement("div");
    divEle.innerHTML = data;
    return divEle;
  },

  deepEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return true;
    }
    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return true;
      }
    }

    return false;
  },

  preventEmoji(event) {
    const emojiPattern =
      /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F800}-\u{1F8FF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{FE00}-\u{FE0F}|\u{1F900}-\u{1F9FF}]/gu;
    const cleanedValue = event.target.value.replace(emojiPattern, "");
    return (event.target.value = cleanedValue);
  },
  preventEmojicontent(html) {
    const emojiPattern =
      /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F800}-\u{1F8FF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{FE00}-\u{FE0F}|\u{1F900}-\u{1F9FF}]/gu;
    if (emojiPattern.test(html)) {
      const cleanedHtml = html.replace(emojiPattern, "");
      return cleanedHtml;
    } else {
      return html;
    }
  },
  preventSpecialCharacters: (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
  },
  preventSpecialCharactersAllowSpace: (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
  },
  preventSpecialCharactersDedication: (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z0-9 .,!'"-]/g, "");
  },
  // For name fields (child's name, parent's name, ...): letters, spaces,
  // hyphens and apostrophes only — covers names like "Mary-Jane" or "O'Neil"
  // without allowing digits or other special characters through.
  preventNonNameCharacters: (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z '-]/g, "");
  },
  filefivemb(e) {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      return { message: "No file selected.", status: false };
    }
    const fileSizeInMB = selectedFile.size / (1024 * 1024);
    if (fileSizeInMB > 5) {
      return { message: "File size should be less than 5 MB.", status: false };
    }
    const allowedExtensions = ["jpeg", "jpg", "png"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    if (
      fileExtension === "jfif" ||
      !allowedExtensions.includes(fileExtension)
    ) {
      return {
        message:
          "Only JPEG, JPG, or PNG files are allowed (JFIF is not supported).",
        status: false,
      };
    }
    return {
      message: "",
      status: true,
    };
  },

  extractText(input) {
    try {
      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(input, "text/html");
      const pElements = Array.from(parsedHtml.querySelectorAll("p"));
      const textArray = pElements.map((node) => node.textContent.trim());
      const combinedText = textArray.join(" ");
      return combinedText;
    } catch (error) {
      return input;
    }
  },
  extractParagraphs(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const isValidDiv =
      doc.body.childNodes.length === 1 &&
      doc.body.firstChild.tagName === "DIV" &&
      Array.from(doc.body.firstChild.childNodes).every(
        (node) => node.tagName === "P",
      );
    if (isValidDiv) {
      return Array.from(doc.querySelectorAll("p")).map((p) => p.textContent);
    } else {
      return htmlString;
    }
  },

  splitTextAndYear(data) {
    let year = data.split(" ");
    const lastElement = year.at(-1);
    const isYearFormat = /^\d{2}$|^\d{4}$/.test(lastElement);

    const div = document.createElement("div");

    if (isYearFormat) {
      const mainText = year.slice(0, -1).join(" ");
      const yearText = lastElement;

      const p1 = document.createElement("p");
      p1.textContent = mainText;

      const p2 = document.createElement("p");
      p2.textContent = yearText;

      div.appendChild(p1);
      div.appendChild(p2);
    } else {
      const p1 = document.createElement("p");
      p1.textContent = data;
      div.appendChild(p1);
    }

    return div.outerHTML;
  },
  compressImageToTargetSize(base64, targetSize = 1) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        const maxSizeInBytes = targetSize * 1024 * 1024;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let quality = 0.9;
        canvas.width = width;
        canvas.height = height;

        const resizeAndCompress = () => {
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          const compressedBase64 = canvas.toDataURL("image/jpeg", quality);

          if (compressedBase64.length <= maxSizeInBytes * 1.37) {
            resolve(compressedBase64);
          } else {
            if (quality > 0.1) {
              quality -= 0.1;
              resizeAndCompress();
            } else {
              reject("Unable to compress image below target size.");
            }
          }
        };

        resizeAndCompress();
      };

      img.onerror = (err) => {
        reject("Error loading the image.");
      };
    });
  },
  normalizeImageExtension(file) {
    if (!file || !file.name) return file;
    const newName = file.name.replace(
      /\.([^.]+)$/,
      (_, ext) => `.${ext.toLowerCase()}`,
    );
    return new File([file], newName, { type: file.type });
  },
};
